/**
 * Package for invoice computation.
 *
 * Stategy enums are imported from constant packages.
 *
 * Strategy:
 *   gstStrategy: 1 - FCM, 2 - RCM
 *   gstSplitStrategy: 1 - INTER_STATE, 2 - INTRA_STATE
 *
 * Data Format:
 *   tax: sgst, cgst, igst
 *   additional_charges: addons of invoice with percentage
 *   total: total of payments or revised total invoice
 */
const { gstType, gstSplitType, AdditionalChargesMethod, PaymentDiscountType } = require('pando-constants');

class Invoice {
  constructor(data, gstStrategy = undefined, gstSplitStrategy = undefined) {
    this.data = data;
    this.gstStrategy = gstStrategy;
    this.gstSplitStrategy = gstSplitStrategy;
    this.total = data.total;
    this.baseFreight = data.baseFreight;
  }

  computeAdditioanlCharges() {
    return (this.data.additionalCharges || []).reduce((acc, additionalCharge) => {
      const additionalChargePercentage = additionalCharge.percentage ?
        (additionalCharge.percentage / 100) : 0;
      const totalAmount = (additionalCharge.type &&
        additionalCharge.type === PaymentDiscountType.BASE_FREIGHT) ? this.baseFreight : this.total;
      let additionalChargeAmount = (totalAmount < 0 ? 0 : totalAmount) * additionalChargePercentage;

      let total = acc.totalAmount;
      if (additionalCharge.method === AdditionalChargesMethod.ADD) {
        additionalChargeAmount = Math.floor(additionalChargeAmount * 100) / 100;
        total = acc.totalAmount + additionalChargeAmount;
      } else if (additionalCharge.method === AdditionalChargesMethod.SUBTRACT) {
        additionalChargeAmount = Math.ceil(additionalChargeAmount * 100) / 100;
        total = acc.totalAmount - additionalChargeAmount;
      }

      const additionalChargeComputed = Object.assign(
        additionalCharge, { amount: additionalChargeAmount });
      return { totalAmount: total,
        additionalCharges: acc.additionalCharges.concat(additionalChargeComputed) };
    }, { totalAmount: this.data.total, additionalCharges: [] });
  }

  getSubTotal() {
    const { totalAmount } = this.computeAdditioanlCharges();
    return totalAmount;
  }

  getTax(totalAmount) {
    const { sgst, cgst, igst } = this.data.tax;
    const taxableAmount = (totalAmount < 0 ? 0 : totalAmount);
    let sgstTaxAmount;
    let cgstTaxAmount;
    let igstTaxAmount;
    let calculatedTax = 0;

    switch (this.gstStrategy) {
      case gstType.FCM: {
        switch (this.gstSplitStrategy) {
          case gstSplitType.INTRA_STATE: {
            sgstTaxAmount = Math.ceil((taxableAmount * sgst)) / 100;
            cgstTaxAmount = Math.ceil((taxableAmount * cgst)) / 100;

            calculatedTax = sgstTaxAmount + cgstTaxAmount;
            break;
          }
          case gstSplitType.INTER_STATE: {
            igstTaxAmount = Math.ceil((taxableAmount * igst)) / 100;
            calculatedTax = igstTaxAmount;
            break;
          }
          default: {
            // Do nothing.
            break;
          }
        }
        break;
      }
      case gstType.RCM: {
        // TODO Any future logic will be added, currently do nothing.
        break;
      }
      default: {
        // Do nothing.
        break;
      }
    }

    return {
      sgstTaxAmount,
      cgstTaxAmount,
      igstTaxAmount,
      calculatedTax,
    };
  }

  getTotal() {
    const { totalAmount, additionalCharges } = this.computeAdditioanlCharges();
    const { sgstTaxAmount, cgstTaxAmount, igstTaxAmount, calculatedTax } =
      this.getTax(totalAmount);
    return {
      sgstTaxAmount,
      cgstTaxAmount,
      igstTaxAmount,
      additionalCharges,
      totalAmount: totalAmount + calculatedTax,
    };
  }
}

module.exports = Invoice;
